export default {
  games: "https://games.scb.ch/",
};
